module.exports = __webpack_public_path__ + "img/erweima.e1a3db9d.jpg";